export default {
  typeLabel: {
    marginBottom: 36,
  },

  dates: {
    display: 'flex',
  },
};
